 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/Title'
 import CONTENTS from '@/components/Contents'
 import INTRODUCTION from '@/components/Introduction'
 import CHAPTER1 from '@/components/Chapter1'
 import CHAPTER11 from '@/components/Chapter11'
 import CHAPTER12 from '@/components/Chapter12'
 import CHAPTER13 from '@/components/Chapter13'
 import CHAPTER14 from '@/components/Chapter14'
 import CHAPTER15 from '@/components/Chapter15'
 import CHAPTER16 from '@/components/Chapter16'
 import CHAPTER17 from '@/components/Chapter17'
 import CHAPTER18 from '@/components/Chapter18'
 import CHAPTER2 from '@/components/Chapter2'
 import CHAPTER21 from '@/components/Chapter21'
 import CHAPTER22 from '@/components/Chapter22'
 import CHAPTER23 from '@/components/Chapter23'
 import CHAPTER24 from '@/components/Chapter24'
 import CHAPTER25 from '@/components/Chapter25'
 import CHAPTER26 from '@/components/Chapter26'
 import CHAPTER27 from '@/components/Chapter27'
 import CHAPTER28 from '@/components/Chapter28'
 import CHAPTER29 from '@/components/Chapter29'
 import CHAPTER210 from '@/components/Chapter210'
 import CHAPTER211 from '@/components/Chapter211'
 import CHAPTER212 from '@/components/Chapter212'
 import CHAPTER213 from '@/components/Chapter213'
 import CHAPTER214 from '@/components/Chapter214'
 import CHAPTER215 from '@/components/Chapter215'
 import CHAPTER216 from '@/components/Chapter216'
 import CHAPTER217 from '@/components/Chapter217'
 import CHAPTER218 from '@/components/Chapter218'
 import CHAPTER219 from '@/components/Chapter219'
 import CHAPTER220 from '@/components/Chapter220'
 import CHAPTER221 from '@/components/Chapter221'
 import CHAPTER222 from '@/components/Chapter222'
 import CHAPTER223 from '@/components/Chapter223'
 import CHAPTER224 from '@/components/Chapter224'
 import CHAPTER225 from '@/components/Chapter225'
 import CHAPTER226 from '@/components/Chapter226'
 import CHAPTER227 from '@/components/Chapter227'
 import CHAPTER228 from '@/components/Chapter228'
 import CHAPTER229 from '@/components/Chapter229'
 import CHAPTER230 from '@/components/Chapter230'
 import CHAPTER231 from '@/components/Chapter231'
 import CHAPTER232 from '@/components/Chapter232'
 import CHAPTER233 from '@/components/Chapter233'
 import CHAPTER234 from '@/components/Chapter234'
 import CHAPTER235 from '@/components/Chapter235'
 import CHAPTER236 from '@/components/Chapter236'
 import CHAPTER237 from '@/components/Chapter237'
 import CHAPTER238 from '@/components/Chapter238'
 import CHAPTER239 from '@/components/Chapter239'
 import CHAPTER240 from '@/components/Chapter240'
 import CHAPTER241 from '@/components/Chapter241'
 import CHAPTER242 from '@/components/Chapter242'
 import CHAPTER243 from '@/components/Chapter243'
 import CHAPTER244 from '@/components/Chapter244'
 import CHAPTER245 from '@/components/Chapter245'
 import CHAPTER246 from '@/components/Chapter246'
 import CHAPTER247 from '@/components/Chapter247'
 import CHAPTER248 from '@/components/Chapter248'
 import CHAPTER249 from '@/components/Chapter249'
 import CHAPTER250 from '@/components/Chapter250'
 import CHAPTER251 from '@/components/Chapter251'
 import CHAPTER252 from '@/components/Chapter252'
 import CHAPTER253 from '@/components/Chapter253'
 import CHAPTER254 from '@/components/Chapter254'
 import CHAPTER255 from '@/components/Chapter255'
 import CHAPTER256 from '@/components/Chapter256'
 import CHAPTER257 from '@/components/Chapter257'
 import CHAPTER258 from '@/components/Chapter258'
 import CHAPTER259 from '@/components/Chapter259'
 import CHAPTER260 from '@/components/Chapter260'
 import CHAPTER261 from '@/components/Chapter261'
 import CHAPTER262 from '@/components/Chapter262'
 import CHAPTER263 from '@/components/Chapter263'
 import CHAPTER264 from '@/components/Chapter264'
 import CHAPTER265 from '@/components/Chapter265'
 import CHAPTER266 from '@/components/Chapter266'
 import CHAPTER267 from '@/components/Chapter267'
 import CHAPTER268 from '@/components/Chapter268'
 import CHAPTER269 from '@/components/Chapter269'
 import CHAPTER270 from '@/components/Chapter270'
 import CHAPTER271 from '@/components/Chapter271'
 import CHAPTER272 from '@/components/Chapter272'
 import CHAPTER273 from '@/components/Chapter273'
 import CHAPTER274 from '@/components/Chapter274'
 import CHAPTER275 from '@/components/Chapter275'
 import CHAPTER276 from '@/components/Chapter276'
 import CHAPTER277 from '@/components/Chapter277'
 import CHAPTER278 from '@/components/Chapter278'
 import CHAPTER279 from '@/components/Chapter279'
 import CHAPTER280 from '@/components/Chapter280'
 import CHAPTER281 from '@/components/Chapter281'
 import CHAPTER282 from '@/components/Chapter282'
 import CHAPTER283 from '@/components/Chapter283'
 import CHAPTER284 from '@/components/Chapter284'
 import CHAPTER285 from '@/components/Chapter285'
 import CHAPTER286 from '@/components/Chapter286'
 import CHAPTER287 from '@/components/Chapter287'
 import CHAPTER288 from '@/components/Chapter288'
 import CHAPTER289 from '@/components/Chapter289'
 import CHAPTER290 from '@/components/Chapter290'
 import CHAPTER291 from '@/components/Chapter291'
 import CHAPTER292 from '@/components/Chapter292'
 import CHAPTER293 from '@/components/Chapter293'
 import CHAPTER294 from '@/components/Chapter294'
 import CHAPTER295 from '@/components/Chapter295'
 import CHAPTER296 from '@/components/Chapter296'
 import CHAPTER297 from '@/components/Chapter297'
 import CHAPTER298 from '@/components/Chapter298'
 import CHAPTER299 from '@/components/Chapter299'
 import CHAPTER2100 from '@/components/Chapter2100'
 import CHAPTER3 from '@/components/Chapter3'
 import CHAPTER31 from '@/components/Chapter31'
 import CHAPTER32 from '@/components/Chapter32'
 import CHAPTER33 from '@/components/Chapter33'
 import CHAPTER34 from '@/components/Chapter34'
 import CHAPTER35 from '@/components/Chapter35'
 import LOVE_2 from '@/components/love_2'
 import SUPPLIERS from '@/components/Suppliers'
 import ABOUT_THE_AUTHORS from '@/components/About_the_Authors'
 import ACKNOWLEDGMENTS from '@/components/Acknowledgments'
 import COPYRIGHT from '@/components/Copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Cover",
 			"name" : "Cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Title",
 			"name" : "Title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/Introduction",
 			"name" : "Introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/Chapter1",
 			"name" : "Chapter1",
 			"component" : CHAPTER1
 		},
 		{
 			"path" : "/Chapter11",
 			"name" : "Chapter11",
 			"component" : CHAPTER11
 		},
 		{
 			"path" : "/Chapter12",
 			"name" : "Chapter12",
 			"component" : CHAPTER12
 		},
 		{
 			"path" : "/Chapter13",
 			"name" : "Chapter13",
 			"component" : CHAPTER13
 		},
 		{
 			"path" : "/Chapter14",
 			"name" : "Chapter14",
 			"component" : CHAPTER14
 		},
 		{
 			"path" : "/Chapter15",
 			"name" : "Chapter15",
 			"component" : CHAPTER15
 		},
 		{
 			"path" : "/Chapter16",
 			"name" : "Chapter16",
 			"component" : CHAPTER16
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js